import {toast} from 'react-toastify'
import Swal from 'sweetalert2'
import {Message} from '../../../_metronic/helpers'
import {addUser, getPartnerUsers, getUsers, updateUserById, assignUserRole} from '../../../api/AdminAPI'
import {UPDATE_MESSAGE} from '../../../utils/contants'
import {AlertProps} from '../../data/AlertDefaults'
import {validatePersonalContactFields} from './userContactValidation'

// export const getUser = (setUser: Function, setAPIStatus: Function) => {
//   setAPIStatus((prev: any) => ({...prev, loading: true}))
//   getUsers().then((res) => {
//     if (res.statusCode === 200) {
//       setUser(res.data?.items)

//       setAPIStatus((prev: any) => ({...prev, loading: false}))
//     } else {
//       setAPIStatus((prev: any) => ({...prev, loading: false, error: res.message}))
//     }
//   })
// }

export const getPartnerUser = (setUser: Function, setAPIStatus: Function, partnerId: string) => {
  setAPIStatus((prev: any) => ({...prev, loading: true}))
  getPartnerUsers(partnerId).then((res) => {
    if (res.statusCode === 200) {
      setUser(res.data)

      setAPIStatus((prev: any) => ({...prev, loading: false}))
    } else {
      setAPIStatus((prev: any) => ({...prev, loading: false, error: res.message}))
    }
  })
}
// Update the handleInputChange function
export const handleInputChange = (event, setInputField, inputField) => {
  const {name, value, type, checked} = event.target

  if (type === 'checkbox') {
    setInputField((prevInputField) => ({
      ...prevInputField,
      [name]: checked,
    }))
  } else if (name === 'inTime') {
    const inTime = new Date(`2000-01-01T${value}`)
    const outTime = new Date(inTime.getTime() + 10 * 60 * 60 * 1000)
    const formattedOutTime = outTime.toTimeString().slice(0, 5)

    setInputField((prevInputField) => ({
      ...prevInputField,
      [name]: value,
      outTime: formattedOutTime,
    }))
  } else {
    setInputField((prevInputField) => ({
      ...prevInputField,
      [name]: name === 'password' && value === '' ? undefined : value,
    }))
  }
}
export const handleSubmit = (
  InputFieldType: {
    firstName: string
    middleName: string
    lastName: string
    email: string
    contact: string
    password: string
    dob: string
    gender: string
    employeeCode: string
    employmentType: string
    designation: string
    startDate: string
    endDate: string
    role: string
    inTime: string
    outTime: string
    reportingManager: string
    personalEmail: string
    hr: string
    address: string //Current Address
    permanentAddress: string  //Permanent Address
    band: string | null
    currentUserEmail: string | null
    partner: string | null
    shiftManagement: string   //Shift Dropdown inside Add user
    departmentId:string| null
    locationId: string   //Location Dropdown inside Add user
    weekendDays: string[]  //Weekend Days
    isPoshCommitteeMember: boolean  //POSH Committee Member
  },
  // getUser: Function,
  setUser: Function,
  setEditId: Function,
  initialState: {
    firstName: string
    middleName: string
    lastName: string
    email: string
    contact: string
    password: string
    dob: string
    role: string
    hr: string
    gender: string
    employeeCode: string
    employmentType: string
    designation: string
    startDate: string
    endDate: string
    inTime: string
    outTime: string
    reportingManager: string
    personalEmail: string
    band: string | null
    shiftManagement: string
    isPoshCommitteeMember: boolean
  },
  setInputField: Function,
  editId: string | null,
  cancelSubmit: Function,
  setAPIStatus: Function,
  setInputError: Function,
  validateForm: Function,
  setSubmitAPIStatus: Function,
  handleClose: Function,
  fetchUsers: Function
) => {
  let {cnt, error} = validateForm(InputFieldType)
  setInputError(error)
  const focusFirstInvalidField = (fieldErrors: Record<string, string>) => {
    const firstField = Object.keys(fieldErrors)[0]
    if (!firstField) return
    window.requestAnimationFrame(() => {
      const field = document.querySelector<HTMLElement>(`[name="${firstField}"]`)
      field?.scrollIntoView({behavior: 'smooth', block: 'center'})
      field?.focus()
    })
  }
  if (cnt > 0) focusFirstInvalidField(error)

  const applyBackendValidationErrors = (response: any) => {
    const fieldMap: Record<string, string> = {
      mobile: 'contact',
      dateOfBirth: 'dob',
      employmentTypeId: 'employmentType',
      designationId: 'designation',
      roleId: 'role',
      hrId: 'hr',
      rmId: 'reportingManager',
      workingShiftId: 'shiftManagement',
    }
    const details = response?.errors || response?.data?.errors || response?.response?.data?.errors
    const entries = Array.isArray(details) ? details : details && typeof details === 'object'
      ? Object.entries(details).map(([field, message]) => ({field, message}))
      : response?.type === 'validation' || response?.property || response?.path
        ? [response]
        : []
    const mappedErrors: Record<string, string> = {}
    const friendlyMessages: Record<string, string> = {
      contact: 'Enter a valid 10-digit mobile number starting with 6, 7, 8, or 9',
      address: 'Enter a valid address (3–255 characters with letters and normal address punctuation).',
      permanentAddress: 'Enter a valid address (3–255 characters with letters and normal address punctuation).',
      emergencyName: 'Enter a valid emergency contact name (2–100 characters with letters).',
      emergencyRelation: 'Enter a valid emergency relation (2–50 characters with letters).',
    }
    entries.forEach((detail: any) => {
      const path = String(detail?.property || detail?.path || detail?.instancePath || detail?.field || detail?.name || '')
      const fieldName = path.split(/[/.]/).filter(Boolean).pop()
      const field = fieldName ? (fieldMap[fieldName] || fieldName) : ''
      const message = String(detail?.message || detail?.error || '')
      if (field && (message || friendlyMessages[field])) {
        const exposesTechnicalDetails = /expected string|pattern|regular expression|\/personal\//i.test(message)
        mappedErrors[field] = friendlyMessages[field] && (field === 'contact' || exposesTechnicalDetails)
          ? friendlyMessages[field]
          : message || 'Please check this field and try again.'
      }
    })
    const serializedResponse = `${String(response?.message || '')} ${JSON.stringify(response || {})}`
    const backendFieldNames: Record<string, string> = {
      mobile: 'contact',
      address: 'address',
      permanentAddress: 'permanentAddress',
      emergencyName: 'emergencyName',
      emergencyRelation: 'emergencyRelation',
    }
    Object.entries(backendFieldNames).forEach(([backendField, frontendField]) => {
      const fieldPath = new RegExp(`(?:/personal/|personal\\.)${backendField}\\b`, 'i')
      if (!mappedErrors[frontendField] && fieldPath.test(serializedResponse) && friendlyMessages[frontendField]) {
        mappedErrors[frontendField] = friendlyMessages[frontendField]
      }
    })
    if (Object.keys(mappedErrors).length) {
      setInputError((previous: any) => ({...previous, ...mappedErrors}))
      focusFirstInvalidField(mappedErrors)
    }
    return Object.keys(mappedErrors).length > 0
  }

  if (cnt === 0) {
    if (editId == null) {
      setSubmitAPIStatus((prev: any) => ({...prev, loading: true}))
      
      // Function to retry role assignment
      const retryRoleAssignment = async (userId: string, roleId: string, maxRetries = 3) => {
        for (let attempt = 1; attempt <= maxRetries; attempt++) {
          try {
            const roleResponse = await assignUserRole(userId, roleId)
            if (roleResponse.statusCode === 200 || roleResponse.statusCode === 201) {
              return true
            }
          } catch (error) {
            if (attempt === maxRetries) {
              throw error
            }
            // Wait 500ms before retry
            await new Promise(resolve => setTimeout(resolve, 500))
          }
        }
        return false
      }

      addUser(InputFieldType).then(async (res) => {
        if (res.statusCode === 201) {
          // If user creation successful, try to assign role with retry logic
          if (InputFieldType.role && res.data?.id) {
            try {
              await retryRoleAssignment(res.data.id, InputFieldType.role)
              toast.success('User created and role assigned successfully')
            } catch (roleError) {
              toast.warning('User created but role assignment failed. Please assign role manually.')
            }
          } else {
            toast.success(res.message)
          }
          
          fetchUsers()
          cancelSubmit(setInputField, initialState, setEditId, setInputError)
          setSubmitAPIStatus((prev: any) => ({...prev, loading: false}))
          handleClose()
        } else {
          const hasFieldErrors = applyBackendValidationErrors(res)
          const responseMessage = String(res?.message || '')
          if (!hasFieldErrors) {
            const isTechnicalValidation = /\/personal\/|expected string to match|regular expression|pattern/i.test(responseMessage)
            Message(isTechnicalValidation ? 'Please review the highlighted fields and try again.' : responseMessage || 'Failed to create user.', 'error')
          }
          setSubmitAPIStatus((prev: any) => ({...prev, loading: false}))
        }
      }).catch((error) => {
        applyBackendValidationErrors(error)
        Message('Failed to create user', 'error')
        setSubmitAPIStatus((prev: any) => ({...prev, loading: false}))
      })
    } else {
      Swal.fire({...AlertProps, icon: 'warning', title: UPDATE_MESSAGE}).then((result: any) => {
        if (result.isConfirmed) {
          setSubmitAPIStatus((prev: any) => ({...prev, loading: true}))
          updateUserById(InputFieldType, editId).then((res) => {
            if (res.statusCode === 200) {
              fetchUsers()
              toast.success(res.message)
              cancelSubmit(setInputField, initialState, setEditId, setInputError)
              setSubmitAPIStatus((prev: any) => ({...prev, loading: false}))
            } else {
              Message(res.message, 'error')
              setSubmitAPIStatus((prev: any) => ({...prev, loading: false}))
            }
          })
        }
      })
    }
  }
}

export const cancelSubmit = (
  setInputField: Function,
  InputField: {
    firstName: string
    middleName: string
    lastName: string
    email: string
    contact: string
    password: string
    dob: string
    gender: string
    role: string
    hr: string
    employmentType: string
    designation: string
    startDate: string
    endDate: string | null
    inTime: string
    outTime: string
    reportingManager: string
    personalEmail: string
    band: string
    shiftManagement: string //Shift Dropdown inside Add user
     departmentId: string | null
  },
  setEditId: Function,
  setShowForm: Function
) => {
  setEditId(null)
  setShowForm(false)
  setInputField(InputField)
}

// begin:: form validation

export const validateForm = (InputField: {
  firstName: string
  middleName: string
  lastName: string
  email: string
  contact: string
  employeeCode: string
  password: string
  dob: string
  gender: string
  employmentType: string
  designation: string
  startDate: string
  endDate: string
  inTime: string
  role: string
  hr: string
  outTime: string
  reportingManager: string
  band: string
  currentUserEmail: string | null
  personalEmail: string
  address: string // Current Address
  permanentAddress: string  //Permannent Address
  emergencyName: string
  emergencyMobile: string
  emergencyRelation: string
  shiftManagement: string   //Shift Dropdown inside Add user
  locationId: string  //Location Dropdown inside Add user
  departmentId: string | null
  weekendDays: string[]  //Weekend Days
  
}) => {
  let cnt = 0
  const error: any = {}

  if (!InputField.firstName.trim()) {
    cnt = cnt + 1
    error.firstName = 'Please enter a First Name.'
  } else {
    // First Name must be at least 2 characters.
    if (InputField.firstName.length < 2) {
      cnt = cnt + 1
      error.firstName = 'First Name must be at least 2 characters.'
    }

    // First Name must not exceed 35 characters.
    if (InputField.firstName.length > 35) {
      cnt = cnt + 1
      error.firstName = 'First Name must not exceed 35 characters.'
    }

    // First Name must contain only alphabetic characters.
    const nameRegex = /^[a-zA-Z]+$/
    if (!nameRegex.test(InputField.firstName)) {
      cnt = cnt + 1
      error.firstName = 'Please enter a valid First Name using only alphabetic characters.'
    }
  }

  if (!InputField.middleName || !InputField.middleName.trim()) {
    cnt++
    error.middleName = 'Middle Name is required'
  } else {
    if (InputField.middleName.length > 35) {
      cnt++;
      error.middleName = 'Middle Name must not exceed 35 characters.';
    }

    const nameRegex = /^[a-zA-Z]+$/;

    if (!nameRegex.test(InputField.middleName)) {
      cnt++;
      error.middleName =
        'Please enter a valid Middle Name using only alphabetic characters.';
    }
  }

  if (!InputField.lastName.trim()) {
    cnt = cnt + 1
    error.lastName = 'Please enter a Last Name.'
  } else {
    // First Name must be at least 2 characters.
    if (InputField.lastName.length < 2) {
      cnt = cnt + 1
      error.lastName = 'Last Name must be at least 2 characters.'
    }

    // First Name must not exceed 35 characters.
    if (InputField.lastName.length > 35) {
      cnt = cnt + 1
      error.lastName = 'Last Name must not exceed 35 characters.'
    }

    // First Name must contain only alphabetic characters.
    const nameRegex = /^[a-zA-Z]+$/
    if (!nameRegex.test(InputField.lastName)) {
      cnt = cnt + 1
      error.lastName = 'Please enter a valid Last Name using only alphabetic characters.'
    }
  }

  const personalContactErrors = validatePersonalContactFields(InputField);
  Object.assign(error, personalContactErrors);
  cnt += Object.keys(personalContactErrors).length;

  // ...

  // Password validation removed - password is auto-generated by backend and sent via email
  // Auto-generated password requirements: One capital letter, one special character, one small letter

  // ...

  if (!InputField.dob.trim()) {
    cnt = cnt + 1
    error.dob = 'Please enter/select a Date of Birth.'
  } else {
    const dobDate = new Date(InputField.dob)
    const currentDate = new Date()
    const minAge = 18

    // Calculate age
    const age =
      currentDate.getFullYear() -
      dobDate.getFullYear() -
      (currentDate.getMonth() < dobDate.getMonth() ||
      (currentDate.getMonth() === dobDate.getMonth() && currentDate.getDate() < dobDate.getDate())
        ? 1
        : 0)

    if (age < minAge) {
      cnt = cnt + 1
      error.dob = `Users must be at least ${minAge} years old to register.`
    }
  }

  if (!InputField.gender.trim()) {
    cnt = cnt + 1
    error.gender = 'Please select a Gender.'
  }
  if (!InputField.employmentType.trim()) {
    cnt = cnt + 1
    error.employmentType = 'Please select a Employment Type.'
  }
  if (!InputField.employeeCode.trim()) {
    cnt = cnt + 1
    error.employeeCode = 'Please enter an Employee Code.'
  } else {
    // Validate employee code format (e.g., CTR-1111)
    const employeeCodeRegex = /^[A-Z]{3}-[0-9]{4}$/
    if (!employeeCodeRegex.test(InputField.employeeCode.trim())) {
      cnt = cnt + 1
      error.employeeCode = 'Employee code must follow format CTR-1111 (3 uppercase letters, hyphen, 4 digits).'
    }
  }
  if (!InputField.startDate.trim()) {
    cnt = cnt + 1
    error.startDate = 'Please enter/select a Date of Joining.'
  }

  if (InputField.endDate.trim() && InputField.startDate.trim()) {
    const endDate = new Date(InputField.endDate)
    const startDate = new Date(InputField.startDate)

    if (endDate < startDate) {
      cnt = cnt + 1
      error.endDate = 'Date of Leaving must be greater than Date of Joining.'
    }
  }

  if (!InputField.inTime.trim()) {
    cnt = cnt + 1
    error.inTime = 'Please enter/select an In Time.'
  }
  if (!InputField.outTime.trim()) {
    cnt = cnt + 1
    error.outTime = 'Please enter/select an Out Time.'
  }

  const baseDate = new Date()

  const [inHours, inMinutes] = InputField.inTime.split(':')
  const [outHours, outMinutes] = InputField.outTime.split(':')

  const inTime = new Date(baseDate)
  inTime.setHours(parseInt(inHours, 10), parseInt(inMinutes, 10), 0, 0)

  const outTime = new Date(baseDate)
  outTime.setHours(parseInt(outHours, 10), parseInt(outMinutes, 10), 0, 0)

  // Check if out time is earlier than in time and adjust for the next day
  if (outTime.getTime() < inTime.getTime()) {
    outTime.setDate(outTime.getDate() + 1)
  }

  const timeDifferenceInMilliseconds = outTime.getTime() - inTime.getTime()
  const timeDifferenceInHours = timeDifferenceInMilliseconds / (1000 * 60 * 60)

  if (timeDifferenceInHours > 10) {
    cnt = cnt + 1
    error.outTime =
      "Please ensure that the 'Out Time' does not exceed 10 hours after the 'In Time', and Please adjust your 'In Time' and 'Out Time' accordingly."
  } else if (timeDifferenceInHours < 4) {
    cnt = cnt + 1
    error.outTime =
      "Please ensure that the 'Out Time' must be at least 4 hours after the 'In Time', and Please adjust your 'In Time' and 'Out Time' accordingly."
  }

  // if (!InputField.band) {
  //   cnt = cnt + 1
  //   error.band = 'Please select a Band.'
  // }

  // if (!InputField.email.trim()) {
  //   cnt = cnt + 1
  //   error.email = 'Please enter an Organization Email.'
  // } else {
  //   const organizationEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  //   if (!organizationEmailRegex.test(InputField.email.trim())) {
  //     cnt = cnt + 1
  //     error.email = 'Please enter a valid Organization Email.'
  //   }
  // }
  // Assuming currentUser is available and contains the email property
  const currentUserEmail = InputField.currentUserEmail
  if (!InputField.email.trim()) {
    cnt = cnt + 1
    error.email = 'Please enter an Organization Email.'
  } else {
    const organizationEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!organizationEmailRegex.test(InputField.email.trim())) {
      cnt = cnt + 1
      error.email = 'Please enter a valid Organization Email.'
    }
    // else if (currentUserEmail) {
    //   const currentUserDomain = currentUserEmail.split('@')[1]
    //   const inputEmailDomain = InputField.email.trim().split('@')[1]
    //   if (currentUserDomain !== inputEmailDomain) {
    //     cnt = cnt + 1
    //     // error.email = 'Organization email domain must match your current email domain.'
    //     error.email = 'Please enter a valid organization email domain.'
    //   }
    // }
  }

  if (!InputField.designation.trim()) {
    cnt = cnt + 1
    error.designation = 'Please select a Designation.'
  }

  if (!InputField.reportingManager.trim()) {
    cnt = cnt + 1
    error.reportingManager = 'Please select a Reporting Manager.'
  }
  // if (!InputField.hr.trim()) {
  //   cnt = cnt + 1
  //   error.hr = 'Please select a Human Resource.'
  // }
  if (!InputField.role) {
    cnt = cnt + 1
    error.role = 'Please select a Role.'
  }


  //Shift Dropdown inside Add user
  if (!InputField.shiftManagement || !InputField.shiftManagement.trim()) {
    cnt = cnt + 1
    error.shiftManagement = 'Please select a Shift.'
  }
  // Location Dropdown inside Add user
  if (!InputField.locationId || !InputField.locationId.trim()) {
    cnt = cnt + 1
    error.locationId = 'Please select a Location.'
  }
  if (!InputField.departmentId) {
  cnt=cnt+1
  error.departmentId = 'Please select a Department.'
}

  // Weekend days validation
  if (!InputField.weekendDays || InputField.weekendDays.length < 1) {
    cnt = cnt + 1
    error.weekendDays = 'Please select at least 1 Week-Off day.'
  }

  if (InputField.weekendDays && InputField.weekendDays.length > 2) {
    cnt = cnt + 1
    error.weekendDays = 'Maximum 2 Week-Off days allowed.'
  }

  // ================= PERSONAL EMAIL =================
  if (!InputField.personalEmail || !InputField.personalEmail.trim()) {
    cnt = cnt + 1
    error.personalEmail = 'Please enter a Personal Email.'
  } else {
    const personalEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!personalEmailRegex.test(InputField.personalEmail.trim())) {
      cnt = cnt + 1
      error.personalEmail = 'Please enter a valid Personal Email.'
    }
  }

  // ================= EMERGENCY CONTACT =================
  if (!InputField.emergencyMobile || !InputField.emergencyMobile.trim()) {
    cnt = cnt + 1
    error.emergencyMobile = 'Emergency mobile number is required.'
  } else if (!/^(\+\d{1,3})?[6-9]\d{9}$/.test(InputField.emergencyMobile)) {
    cnt = cnt + 1
    error.emergencyMobile = 'Enter a valid 10-digit mobile number.'
  }

  return {error, cnt}
}
